import { Map } from "immutable";
import { getCookie } from "./session";
import { secretKey } from "../../config";
var jwt = require("jsonwebtoken");

export function clearToken() {
  localStorage.removeItem("id_token");
}

export function getToken() {
  try {
    const idToken = localStorage.getItem("id_token");
    return new Map({ idToken });
  } catch (err) {
    clearToken();
    return new Map();
  }
}

export function arrayEqual(array1, array2) {
  return array1.sort().toString() === array2.sort().toString();
}

export function timeDifference(givenTime) {
  givenTime = new Date(givenTime);
  const milliseconds = new Date().getTime() - givenTime.getTime();
  const numberEnding = (number) => {
    return number > 1 ? "s" : "";
  };
  const number = (num) => (num > 9 ? "" + num : "0" + num);
  const getTime = () => {
    let temp = Math.floor(milliseconds / 1000);
    const years = Math.floor(temp / 31536000);
    if (years) {
      const month = number(givenTime.getUTCMonth() + 1);
      const day = number(givenTime.getUTCDate());
      const year = givenTime.getUTCFullYear() % 100;
      return `${day}-${month}-${year}`;
    }
    const days = Math.floor((temp %= 31536000) / 86400);
    if (days) {
      if (days < 28) {
        return days + " day" + numberEnding(days);
      } else {
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const month = months[givenTime.getUTCMonth()];
        const day = number(givenTime.getUTCDate());
        return `${day} ${month}`;
      }
    }
    const hours = Math.floor((temp %= 86400) / 3600);
    if (hours) {
      return `${hours} hour${numberEnding(hours)} ago`;
    }
    const minutes = Math.floor((temp %= 3600) / 60);
    if (minutes) {
      return `${minutes} minute${numberEnding(minutes)} ago`;
    }
    return "a few seconds ago";
  };
  return getTime();
}

export function stringToInt(value, defValue = 0) {
  if (!value) {
    return 0;
  } else if (!isNaN(value)) {
    return parseInt(value, 10);
  }
  return defValue;
}
export function stringToPosetiveInt(value, defValue = 0) {
  const val = stringToInt(value, defValue);
  return val > -1 ? val : defValue;
}

export function getQueryStringFrmObject(param) {
  //make sure params contain info object
  var queryString = Object.keys(param.info)
    .map((key) => key + "=" + param.info[key])
    .join("&");
  return queryString;
}

export function redirectPage(status) {
  window.location.href = status;
}
export function dateAddedFormatter(mongoDate) {
  var __date = new Date(mongoDate);
  var monthIndex = String(__date.getMonth() + 1).padStart(2, "0");
  var day = String(__date.getDate()).padStart(2, "0");
  var year = __date.getFullYear();
  return year + "-" + monthIndex + "-" + day;
}
//NEW FUNCTION- for extracting time from ISODate format
// export function timeFromISODate(date){
//   var dateTime = new Date(date * 1000);
//   var hrs = dateTime.getHours();
//   var mins = dateTime.getMinutes();
//   var secs = dateTime.getSeconds();
//   hrs = hrs.toString().padStart(2, "0");
//   mins = mins.toString().padStart(2, "0");
//   secs = secs.toString().padStart(2, "0");
//   return hrs +":"+ mins + ":" + secs;
// }

export function dateFormatter(mongoDate, withTime) {
  var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"];
  var __date = new Date(mongoDate * 1000);
  var monthIndex = __date.getMonth();
  var day = __date.getDate();
  var year = __date.getFullYear();
  var hours = __date.getHours();
  var minutes = __date.getMinutes();
  var seconds = __date.getSeconds();
  day = day.toString().padStart(2, '0');
  hours = hours.toString().padStart(2, "0");
  minutes = minutes.toString().padStart(2, "0");
  seconds = seconds.toString().padStart(2, "0");
  if (withTime) {
    return day + " " + monthNames[monthIndex] + ", " + year + " - " + hours + ":" + minutes + ":" + seconds;
  } else {
    return day + " " + monthNames[monthIndex] + ", " + year;
  }
}
var addedTime = 19800;
//Get Date From TimeStamp
export function getDateFromTS(timeStamp) {
  var date = "";
  date = new Date((timeStamp + addedTime) * 1000);
  var year = date.getUTCFullYear();
  var month = String(date.getUTCMonth() + 1).padStart(2, "0");
  var day = String(date.getUTCDate()).padStart(2, "0");
  date = year + "-" + month + "-" + day;
  return date;
}

//Get Date From TimeStamp
export function getDateFromFullTS(timeStamp) {
  var date = "";
  date = new Date(timeStamp + addedTime);
  var year = date.getUTCFullYear();
  var month = String(date.getUTCMonth() + 1).padStart(2, "0");
  var day = String(date.getUTCDate()).padStart(2, "0");
  date = year + "-" + month + "-" + day;
  return date;
}
//Date from ISO date
export function getDateFromISODate(isoDate) {
  var d = isoDate;
  function pad(n) {
    return (n < 10 ? "0" : "") + n;
  }
  return d.getUTCFullYear() + "-" + pad(d.getUTCMonth() + 1) + "-" + pad(d.getUTCDate());
  // return date;
}
/**
 * Global POST Api Call Function
 * @param {* Api Url} endPoint
 * @param {* Data Object } pojo
 */
export async function postApi(endPoint, pojo) {
  var apiResponse = await fetch(endPoint, {
    method: "post",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      authorization: getCookie("id_token") ? getCookie("id_token") : "",
    },
    body: JSON.stringify(pojo),
  })
    .then(function (response) {
      return response.json();
    })
    .catch((err) => {
      console.error("Fetch post ERROR:", err);
    });
  if (apiResponse) {
    return apiResponse;
  } else {
    return {};
  }
}

/**
 * Global GET Api Call Function
 * @param {* Api Url} endPoint
 * @param {* Id to be Appended} id
 */
export async function getApi(endPoint, id) {
  let finalEndPoint = endPoint ? endPoint : "";
  if (id) {
    finalEndPoint = finalEndPoint + id;
  }
  var apiResponse = await fetch(finalEndPoint, {
    method: "get",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      authorization: getCookie("id_token") ? getCookie("id_token") : "",
    },
  })
    .then(function (response) {
      return response.json();
    })
    .catch((err) => {
      console.error("Fetch Get ERROR:", err);
    });
  if (apiResponse) {
    console.log("finalEndPoint1111111", apiResponse);
    return apiResponse;
  } else {
    return {};
  }
}
/**
 * Global FORM-DATA POST Api Call Function
 * @param {* Api Url} endPoint
 * @param {* Data Object } pojo
 */
export async function postFormDataApi(endPoint, formdata) {
  var apiResponse = await fetch(endPoint, {
    method: "post",
    headers: {
      Accept: "application/json",
      authorization: getCookie("id_token") ? getCookie("id_token") : "",
    },
    body: formdata,
  })
    .then(function (response) {
      return response.json();
    })
    .catch((err) => {
      console.error("Fetch post ERROR:", err);
    });
  if (apiResponse) {
    return apiResponse;
  } else {
    return {};
  }
}
/**
 * Global POST Api Call Function
 * @param {* Api Url} endPoint
 * @param {* Data Object } pojo
 */
export async function deleteApi(endPoint, pojo) {
  var apiResponse = await fetch(endPoint, {
    method: "delete",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      authorization: getCookie("id_token") ? getCookie("id_token") : "",
    },
    body: JSON.stringify(pojo),
  })
    .then(function (response) {
      return response.json();
    })
    .catch((err) => {
      console.error("Fetch post ERROR:", err);
    });
  if (apiResponse) {
    return apiResponse;
  } else {
    return {};
  }
}

/**
 * Global POST Api Call Function
 * @param {* Api Url} endPoint
 * @param {* Data Object } pojo
 */
export async function putApi(endPoint, pojo) {
  var apiResponse = await fetch(endPoint, {
    method: "put",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      authorization: getCookie("id_token") ? getCookie("id_token") : "",
    },
    body: JSON.stringify(pojo),
  })
    .then(function (response) {
      return response.json();
    })
    .catch((err) => {
      console.error("Fetch post ERROR:", err);
    });
  if (apiResponse) {
    return apiResponse;
  } else {
    return {};
  }
}

export function getDataFromToken() {
  var token = getCookie("id_token");
  console.log("token", token);
  if (token) {
    var userData = jwt.verify(token, secretKey);
    console.log("tokenuserData", userData);
    if (userData && userData !== undefined) {
      return userData;
    }
  } else {
    return {};
  }
}

export function array_move(arr, old_index, new_index) {
  // if (new_index >= arr.length) {
  //     var k = new_index - arr.length + 1;
  //     while (k--) {
  //         arr.push(undefined);
  //     }
  // }
  arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
  return arr;
}

/**
 * calculate vpoint
 */
export function calVPoints(vfnl) {
  var vPoints = null;
  if (vfnl === null) {
    return null;
  }
  if (vfnl >= 0 && vfnl <= 40) {
    vPoints = 0;
    return vPoints;
  } else if (vfnl > 40 && vfnl <= 60) {
    vPoints = 1;
    return vPoints;
  } else if (vfnl > 60 && vfnl <= 67) {
    vPoints = 2;
    return vPoints;
  } else if (vfnl > 67 && vfnl <= 75) {
    vPoints = 3;
    return vPoints;
  } else if (vfnl > 75 && vfnl <= 80) {
    vPoints = 4;
    return vPoints;
  } else if (vfnl > 80 && vfnl <= 90) {
    vPoints = 5;
    return vPoints;
  } else if (vfnl > 90 && vfnl <= 95) {
    vPoints = 6;
    return vPoints;
  } else if (vfnl > 95 && vfnl < 100) {
    vPoints = 7;
    return vPoints;
  } else if (vfnl == 100) {
    vPoints = 8;
    return vPoints;
  } else {
    return vPoints;
  }
}

export function calVPointsColOne(vfnl) {
  var vPoints = null;
  if (vfnl === null) {
    return null;
  }
  if (vfnl >= 0 && vfnl < 25) {
    vPoints = 0;
    return vPoints;
  } else if (vfnl >= 25 && vfnl < 43) {
    vPoints = 1;
    return vPoints;
  } else if (vfnl >= 43 && vfnl < 52) {
    vPoints = 2;
    return vPoints;
  } else if (vfnl >= 52 && vfnl < 63) {
    vPoints = 3;
    return vPoints;
  } else if (vfnl >= 63 && vfnl < 67) {
    vPoints = 4;
    return vPoints;
  } else if (vfnl >= 67 && vfnl < 80) {
    vPoints = 5;
    return vPoints;
  } else if (vfnl >= 80 && vfnl < 90) {
    vPoints = 6;
    return vPoints;
  } else if (vfnl >= 90 && vfnl < 100) {
    vPoints = 7;
    return vPoints;
  } else if (vfnl == 100) {
    vPoints = 8;
    return vPoints;
  } else {
    return vPoints;
  }
}

export function timeout(ms, promise) {
  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => {
      reject(new Error("TIMEOUT"));
    }, ms);

    promise
      .then((value) => {
        clearTimeout(timer);
        resolve(value);
      })
      .catch((reason) => {
        clearTimeout(timer);
        reject(reason);
      });
  });
}
